import { render, staticRenderFns } from "./HeraConfirmCopyLinkError.vue?vue&type=template&id=2e63bae7&"
import script from "./HeraConfirmCopyLinkError.vue?vue&type=script&lang=js&"
export * from "./HeraConfirmCopyLinkError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports